import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SelectListItemDto, UserPermissionServiceProxy, WarehouseSelectListDto } from '../../../../../../../../../shared/service-proxies/service-proxies';
import { ShoppingCardService } from '../../services/shopping-card.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';
import { TestService } from 'test/service/test.service';

@Component({
  selector: 'kt-from-receive-warehouse',
  templateUrl: './from-receive-warehouse.component.html',
  styleUrls: ['./from-receive-warehouse.component.scss']
})
export class FromReceiveWarehouseComponent implements OnInit, OnDestroy {
	

	//Dynamic componentin basıldığı yere data göndermemizi sağlar.
	//Yani bu componentten başka bir componente burada ki datayı gönderiyoruz.
	dynamicComponentObject = new Subject();

	//Combobox içerisinde seçilen  warehouse ngModel ile yakalarız
	selectedWarehouse = new WarehouseSelectListDto();

	//Combobox içerisine doldurulacak olan warehouse listesini tutar.
	warehouses = new BehaviorSubject<WarehouseSelectListDto[]>([]);

	warehouseReceives = new BehaviorSubject<WarehouseSelectListDto[]>([]);

	selectedDeliveredWarehouse = new WarehouseSelectListDto();

	constructor(private _userPermissionService: UserPermissionServiceProxy,
		private shoppingCardService: ShoppingCardService,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService
) { }

	ngOnInit() {

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.FROMRECEIVEWAREHOUSE.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.FROMRECEIVEWAREHOUSE.FROMRECEIVEWAREHOUSE.SUBHEADER"));


		//Kullanıcı bazlı olarak WareHouse listesini bize verir.
		this._userPermissionService.getFromReceiveWarehoseByUserAuths().subscribe((wareHouses: WarehouseSelectListDto[]) => {

			this.warehouses.next(wareHouses);
		})

	}

	//Combobox içerisinde ki herhangi bir değişimi yakaladığımız methoddur.
	onChangeWareHouse() {

		//this.dynamicComponentObject.next(this.selectedWarehouse);

		this.shoppingCardService.resetItems();


		if (!this.selectedWarehouse) {

			this.selectedDeliveredWarehouse = null;
			this.warehouseReceives.next(null);

			this.dynamicComponentObject.next({

				requestWarehouse: this.selectedWarehouse,
				receiveWarehouse: this.selectedDeliveredWarehouse,

			});

		}
		else {
			this.getToReceiveWarehouse();

		}
	
	}

	getToReceiveWarehouse() {

		var requestWarehouse = this.selectedWarehouse;
		var id = requestWarehouse.id;
		var name = requestWarehouse.name;
		var code = requestWarehouse.code;
		var addressId = requestWarehouse.addressId;
		var isSelected = requestWarehouse.isSelected;

		this._userPermissionService.getToReceiveWarehoseByUserAuths(id, name, code, addressId, isSelected)
			.subscribe(result => {
				console.log(result);
				this.warehouseReceives.next(result);
				var selectWarehouse = result.find(x => x.isSelected == true);

				if (selectWarehouse) {
					this.selectedDeliveredWarehouse = selectWarehouse;
				}

				this.dynamicComponentObject.next({

					requestWarehouse: this.selectedWarehouse,
					receiveWarehouse: this.selectedDeliveredWarehouse,

				});

			})
	}


	onChangeDeliveredWareHouse() {


		this.dynamicComponentObject.next({

			requestWarehouse: this.selectedWarehouse,
			receiveWarehouse: this.selectedDeliveredWarehouse,
			
		});


		//this.dynamicComponentObject.next(this.selectedWarehouse);

	}

	ngOnDestroy() {

		this._testService.setTitle(" ");
		this._testService.setDesc(" ");

		this.dynamicComponentObject.unsubscribe();
		this.warehouses.unsubscribe();

	}
}
